import ApiProvider from "../../../lib/providers/ApiProvider";
import { serviceUtil } from "../../commons/utils/services";
import { HeadersMapping } from "../../commons/mappings/headers.mapping";
import { URLConfiguration } from "../../commons/constants/url.configuration";
import ConfirmarInformacionRequest from "../../commons/mappings/confirmarInformacionRequest.mapping";

class ConfirmarInformacionProvider {
    
    constructor() {
        this.paths                          = URLConfiguration.paths;
        this.confirmarInformacionRequest    = new ConfirmarInformacionRequest();
        this.apiProvider                    = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH)
    }

    patchConfirmarInformacion = async (datosConsulta) => {
        const headers   = HeadersMapping.getHeaderService();
        const request   = this.confirmarInformacionRequest.patchConfirmarInformacion(datosConsulta);
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.simulacionProductosRentas.confirmaInformacion, { idSimulacion: datosConsulta.idSimulacion });
        let response    = null;
        try {
            response = await this.apiProvider.patch( pathNew, request, { headers } );
        } catch (error) {
            console.log(error);
        }
        return response;
    }

}

export default ConfirmarInformacionProvider;